module.exports = __webpack_public_path__ + "static/media/rp-initials-flag-red.16198a87.svg";